import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { Department } from '../../onboarding/classes/department';

@Injectable()
export class DepartmentService {

  constructor(private http: Http) { }

  getDepartments(orgId: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.get(`${environment.organizationsUrl}${orgId}/${environment.departmentsUrl}`, options)
      .map(res => res.json())
  }

  addDepartment(orgId: number, dep: Department) {
    let data = { department: dep, commit: 'Complete' }
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.post(`${environment.organizationsUrl}${orgId}/${environment.departmentsUrl}`, data, options)
      .map(res => res.json())
  }

  editDepartment(orgId: number, id: number, dep: Department) {
    let data = { department: dep, commit: 'Complete', organiation_id: orgId, id }
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.patch(`${environment.organizationsUrl}${orgId}/departments/${id}.json`, data, options)
      .map(res => res.json())
  }

  deleteDepartment(orgId: number, id: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.delete(`${environment.organizationsUrl}${orgId}/departments/${id}.json`, options)
      .map(res => res.json())
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/services/department.service.ts